module.exports = __webpack_public_path__ + "img/tpc-web-1.be4e3363.jpg";